interface Props {
  className?: string;
  rounded?: 'md' | 'lg' | 'pill' | 'sm';
  height?: number | string;
  width?: number | string;
}

export function Skeleton({ className = '', rounded = 'md', height, width }: Props) {
  const r = rounded === 'pill' ? 'rounded-pill' : `rounded-${rounded}`;
  return (
    <div
      className={`bg-text/10 animate-pulse ${r} ${className}`}
      style={{ height, width }}
    />
  );
}
